import CImage from "components/CImage"
import { useEffect, useState } from "react"
import { Row } from "style/preset"
import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"
import CInputCom from "./CInputCom"


interface CSelectProps {
    label?: string
    value: string
    options: any[]
    onChange: (val: unknown) => void,
    optionKey?: string
    optionValue?: string
    optionImg?: string
    showImg?:boolean
}

const CSelectCom = ({label = '', value, options, onChange, optionKey="label", optionValue="value", optionImg="imgUrl", showImg=false}: CSelectProps) => {
    const [isFocus, setIsFocus] = useState(false)
    const [filter, setFilter] = useState('')
    const [curOption, setCurOption] = useState<any>(null)
    const [dataList, setDataList] = useState<any>([])
    const [oldCurOption, setOldCurOption] = useState<any>(null)

    useEffect(() => {
        if(options.length && value) {
            const obj = options.find((item: any) => item[optionValue] === value)
            if(obj) {
                setCurOption(obj)
            } else {
                setCurOption({})
            }
        }
    }, [value, options, optionKey, optionValue])

    useEffect(() => {
        if(options.length) {
            setDataList(options)
        }
    }, [options])

    const fnInputChange = (val: string) => {
        setFilter(val)
    }

    useEffect(() => {
        if(filter) {
            const tempAry = options.filter((item:any) => item[optionKey].toLowerCase().includes(filter.toLowerCase()) || item['nickName']?.toLowerCase().includes(filter.toLowerCase()))
            setDataList(tempAry)
        } else {
            setDataList(options)
        }
    }, [filter, optionKey, options])

    const fnFocus = () => {
        setIsFocus(true)
        setCurOption(null)
    }

    const fnBlur = () => {
        setIsFocus(false)
        if(!curOption && oldCurOption) {
            setCurOption(oldCurOption)
        }
    }

    const fnChange = (item: any) => {
        onChange(item)
        setCurOption(item)
        setOldCurOption(item)
        fnBlur()

    }

    return <CSelectWrap>
        <CInputCom value={(curOption && curOption[optionKey])|| filter} label={label} placeholder="Start typing" onChange={(val: string) => fnInputChange(val)} onFocus={fnFocus}></CInputCom>
        {
            isFocus && !!dataList.length && <COptionsMaskingWrap onClick={fnBlur}></COptionsMaskingWrap>
        }
        {
            isFocus && !!dataList.length && <COptionsWrap>
                {
                     dataList.map((item:any, index:number) => <COptionItemWrap key={index} onClick={() => fnChange(item)}>
                        {
                            showImg && <CImage src={item[optionImg]} mr="10px" width="26px" height="26px"></CImage>
                        }
                        <COptionItemLabelWrap>{item[optionKey]}</COptionItemLabelWrap>
                    </COptionItemWrap>)
                }
            </COptionsWrap>
        }
        {
            showImg &&  !!curOption &&  <CImage position="absolute" top="22px" left="92%" src={curOption[optionImg]} width="22px" height="22px"></CImage>
        } 
    </CSelectWrap>
}

const CSelectWrap = styled(StyledContainer)`
    position: relative;
`

// 选项列表
const COptionsMaskingWrap = styled(StyledContainer)`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
`

const COptionsWrap = styled(StyledContainer)`
    position: absolute;
    z-index: 2;
    top: 72px;
    max-height: 300px;
    border-radius: 9px;
    border: 1px solid #DFE0E2;
    background-color: #FAFAFA;
    width: 100%;
    overflow: auto;
`

const COptionItemWrap = styled(Row)`
    height: 60px;
    padding: 17px 20px;
    background-color: #ffffff;
    margin: 10px;
    box-sizing: border-box;
    border-radius: 9px;
    cursor: pointer;
    box-shadow: 0px 2px 2px -2px rgba(24, 39, 75, 0.06), 0px 1px 2px 0px rgba(24, 39, 75, 0.08);

    &:hover {
        box-shadow: 0px 10px 32px -4px rgba(24, 39, 75, 0.10), 0px 6px 14px -6px rgba(24, 39, 75, 0.12);
    }
`

const COptionItemLabelWrap = styled(StyledContainer)`
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
`

export default CSelectCom